import React from "react";
import Avatar from "@mui/material/Avatar";
import Skeleton from "@mui/material/Skeleton";
import { useContact } from "@seabrookstudios/pitch2table";
import CardMedia from "@mui/material/CardMedia";
import { FullScreenDialog } from "../core/FullScreenDialog";
import { UploadUserAvatar } from "./UploadUserAvatar";
import { useMyProfile } from "@seabrookstudios/pitch2table";

/**
 * @param {object} props
 * @param {import('@seabrookstudios/types').UserId|undefined} props.userId
 */
export const UserAvatar = ({ userId }) => {
  const { data: profile } = useContact(userId);

  if (!profile) {
    return <Skeleton variant="circular" />;
  }

  return <Avatar src={profile ? profile.pictureUrl : ""} />;
};

export const ThisUserAvatar = () => {
  const { data: profile } = useMyProfile();

  if (!profile) {
    return <Skeleton variant="circular" />;
  }

  return <Avatar src={profile ? profile.pictureUrl : ""} />;
};

/**
 * @param {object} props
 * @param {boolean} [props.editable]
 */
export const UserAvatarCardCover = ({ editable = false }) => {
  const { data: contact } = useMyProfile();

  if (!contact) {
    return <Skeleton variant="circular" />;
  }

  if (editable && !contact.pictureUrl) {
    return <UploadUserAvatar />;
  }

  if (!editable) {
    return (
      <CardMedia
        key={contact.pictureUrl}
        component="img"
        sx={{ maxHeight: 200, objectFit: "contain" }}
        image={contact.pictureUrl}
        title={`Avatar image for ${contact.preferredName}`}
      />
    );
  }

  return (
    <FullScreenDialog
      Icon={() => (
        <CardMedia
          key={contact.pictureUrl}
          component="img"
          sx={{ maxHeight: 200, objectFit: "contain" }}
          image={contact.pictureUrl}
          title={`Avatar image for ${contact.preferredName}`}
        />
      )}
      iconAlign="center"
      title="Replace User Avatar"
      canSave={true}
    >
      <UploadUserAvatar />
    </FullScreenDialog>
  );
};
